import React from 'react';
import PropTypes from 'prop-types';

export class Container extends React.Component {
  render() {
    return <div className='container is-fluid is-gapless'>
      <section className={this.props.className}>
        <div className='columns'>
          <div className='column'>
            {this.props.children}
          </div>
        </div>
      </section>
    </div>;
  }
}

Container.propTypes = {
  isHalf: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/common/components/Container.jsx